<template>
  <ol v-if="staticData && staticData.length" class="inner-grid">
    <li v-for="(teaser, index) in staticData" :key="`labeled_teaser_${teaser.article?.id}`">
      <TeaserConditionalPosterBlock
        v-bind="{
          ...teaser.article,
          ...useImagePriority(_index === 0 ? 'high' : 'auto', 2, index),
        }"
        :sub-title="teaser.label"
        :show-date="false"
        :show-label="false"
        aspect-ratio-block="16x9"
        aspect-ratio-poster="3x2"
        :heading-level="2"
        :analytics="{
          linkAnalyticsTag: 'content-labeled-teasers',
        }"
      />
    </li>
  </ol>
</template>

<script setup lang="ts">
import type { ICmsContentLabeledTeasers } from '~~/types/_cms-types';
import useImagePriority from '~/composables/useImagePriority';

interface IProps {
  staticData?: Array<ICmsContentLabeledTeasers>;
  _index: number;
}

withDefaults(defineProps<IProps>(), {
  staticData: undefined,
  _index: 0,
});
</script>

<style scoped lang="postcss">
.inner-grid {
  --inner-grid-gap: var(--unit-8);
  --inner-grid-columns: 1fr;

  display: grid;
  gap: var(--inner-grid-gap);
  grid-template-columns: var(--inner-grid-columns);

  @media (--md-viewport) {
    --inner-grid-gap: var(--unit-16);
    --inner-grid-columns: repeat(2, 1fr);
  }

  @media (--lg-viewport) {
    --inner-grid-gap: var(--unit-24);
  }
}
</style>
